import { datadogRum } from '@datadog/browser-rum';

const DATADOG_CONFIG = {
  applicationId: '7e9a6dd3-0c34-47c6-939b-ecd2c44f7116',
  clientToken: 'pub56ec8d81448e378f0cc8d1ed9cd1bd2d',
  site: 'datadoghq.com',
  service: 'bright-finder',
  env: import.meta.env.NODE_ENV,
  sessionSampleRate: import.meta.env.VUE_APP_DATADOG_SESSION_SAMPLE_RATE || 100,
  sessionReplaySampleRate: import.meta.env.VUE_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE || 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
};

if (window.DATADOG_RUM_ENABLED) {
  if (!window.dataDogInitialized) {
    window.dataDogInitialized = true;
    datadogRum.init(DATADOG_CONFIG);
  }
}
